export const emailRegex = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*[;&,]{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/

export const toSnakeCase = str => str
                                  .toLowerCase()
                                  .replace(/[\s-]+/g, '_')
                                  .replace(/[^a-z0-9_]/g, '')
                                  .replace(/_+/g, '_')
                                  .replace(/^_+|_+$/g, '');
